// Handle analytics script after static page load (WP Fastest Cache or WP Super Cache) //

function enableGTM(gtmCode) {
  document.querySelectorAll('.sp-cookies.gtm').forEach((script) => {
    script.type = 'text/javascript';
    // eslint-disable-next-line no-eval
    eval(script.innerHTML);
  });

  // Inject noscript iframe manually
  const gtmIframe = document.createElement('iframe');
  gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmCode}`;
  gtmIframe.height = '0';
  gtmIframe.width = '0';

  document.body.appendChild(gtmIframe);
}

function getGTMCode() {
  const script = document.querySelector('.sp-cookies.gtm');
  if (!script) return null;

  const match = script.innerHTML.match(/'GTM-[^']+'/);
  return match ? match[0].replace(/'/g, '') : null;
}

if (!document.body.classList.contains('preview')) {
  window.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('.sp-cookies.gtm');
    if (scripts && Cookies.get('performance_cookie')) {
      const gtmCode = getGTMCode();
      loadScripts(scripts);
      enableGTM(gtmCode);
    }
  });

  const loadScripts = (scripts) => {
    scripts.forEach((script) => {
      script.type = 'text/javascript';
      document.head.appendChild(script);
    });
  };
}

// *******************************************************************************
// GTM - Consent Default
// *******************************************************************************

const initConsentDefault = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // gtag commands must be pushed as the arguments object, not an array
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments);
  }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });

  const performanceCookie = Cookies.get('performance_cookie');
  const advertisingCookie = Cookies.get('advertising_cookie');

  const updateData = {};
  if (advertisingCookie) {
    updateData.ad_storage = 'granted';
  }

  if (performanceCookie) {
    updateData.analytics_storage = 'granted';
  }

  gtag('consent', 'update', updateData);
};

// Only when GTM is gated by our cookie banner; otherwise consent is handled by the CMP inside GTM (Cookiebot)
if (document.querySelector('.sp-cookies.gtm')) {
  initConsentDefault();
}

// *******************************************************************************
// GA4 ecommerce events (dataLayer)
// *******************************************************************************

// eslint-disable-next-line no-unused-vars
const pushEcommerceEvent = (event, ecommerce) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ecommerce: { currency: 'EUR', ...ecommerce } });
};
